

export default class Background extends Phaser.GameObjects.TileSprite {
    constructor(config) {
        super(config.scene, 0, 86, config.width, config.height, config.key, config.speed);
        this.scene = config.scene;
        this.speed = config.speed;
        this.scene.add.existing(this);
        this.setOrigin(0, 0);
        this.setScrollFactor(0);
        this.setDepth(0);
    }
    update(isPaused = false, speedCoefficient = 1.5) {
        this.tilePositionX +=  isPaused ? 0 : this.speed * speedCoefficient;
    }
}